import { defineComponent, h } from 'vue';
import { QInput, QIcon } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';

export default defineComponent({
    name: 'form-input',
    components: { QInput, QIcon },
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        ...utils.forms.computed,
        headercontrols: function () {
            const h = this.$createElement;
            const items = [];
            if (this.schema.formatData && this.schema.formatData.Controls && Array.isArray(this.schema.formatData.Controls) && this.schema.formatData.Controls.length > 0) {
                for (let i = 0; i < this.schema.formatData.Controls.length; i++) {
                    const c = this.schema.formatData.Controls[i];

                    let DynamicControl = utils.getDynamicComponent(h, c);

                    if (!DynamicControl)
                        DynamicControl = 'default-unknown';

                    items.push(
                        <DynamicControl
                            type={c.ControlType}
                            name={c.ControlData && c.ControlData.Name ? c.ControlData.Name : ''}
                            root={this.root}
                            parentType="HorizontalStack"
                            controlData={c.ControlData}
                            controlURL={c.ControlURL}
                            controlName={c.Name}
                            accessPermission={c.AccessPermission}
                            cacheControl={c.CacheControl}
                            controlEvents={c.Events}>
                        </DynamicControl>);
                }
            }
            return <div style="display: flex; flex-direction: row;">{items}</div>;
        },
    },
    methods: {
        ...methods,
        sync(prop, value) {
            this.cmodel[prop] = value;
        },
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        schema: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
        propertygrid: false,
    },
    render() {
        try {
            if (!this.Condition)
                return null;

            let desc;
            if (this.schema.description)
                desc = <i class="mdi mdi-information" title={this.schema.description} style={{ color: "var(--v-checkboxGrey-base)", fontSize: "small", marginLeft: "3px" }}></i>;

            let err;
            if (this.schema.formatData?.error)
                err = utils.tt(this.schema.formatData.error, <QIcon name="mdi-alert" size="xs" color="negative" />);

            const name = <span style={{ marginLeft: (this.child * 15) + "px" }}>{this.name}</span>;

            let buttons = [];

            if (this.schema.formatData?.buttons)
                for (let btn of this.schema.formatData?.buttons)
                    buttons.push(
                        utils.tt(btn.tooltip, <QIcon name={btn.icon} size="xs" onClick={(e) => btn.action(e, this.cmodel[this.schemakey])} />)
                    );

            if (this.schema.formatData?.EllipsisButton)
                buttons.push(
                    <QIcon name="mdi-dots-horizontal" size="xs" style="cursor: pointer;"
                        onClick={(e) => this.schema.formatData?.EllipsisButton(e, this.cmodel[this.schemakey], (value) => this.sync(this.schemakey, value))}
                    />
                );

            const appendSlot = buttons.length ? { append: () => buttons } : undefined;

            let input;
            if (this.readonly)
                input = <QInput class="caption pa-0 ma-0" outlined dense hide-bottom-space style={{ width: "100%" }} modelValue={this.cmodel[this.schemakey]} readonly />;
            else
                input = <QInput class="caption pa-0 ma-0"
                    outlined
                    dense
                    hide-bottom-space
                    style={{ width: "100%" }}
                    modelValue={this.cmodel[this.schemakey]}
                    onUpdate:modelValue={(value) => this.sync(this.schemakey, value)}>
                    {appendSlot}
                </QInput>;

            if (this.schema.format == 'inputWithHeaderBar' && this.schema.formatData) {
                // Special version of input with a header bar and a list of controls
                //const header = (
                //    <stack-vertical type="HorizontalLayout" name={this.name} root={this.root} parentType="InputWithHeaderBar" controlData={this.schema.formatData}>
                //    </stack-vertical>
                //);
                input = <div style="display: flex; flex-direction: column;" class={{ "property-grid": this.propertygrid }}>{this.headercontrols}{input}</div>;
            }

            return (
                <tr class="pa-0 ma-0">
                    <td style={{ width: "1px" }}>
                        <span style={{ whiteSpace: "nowrap" }}>{name} {desc}{err}</span>
                    </td>
                    <td className="pa-0 ma-0" class={{ "property-grid": this.propertygrid }} xstyle="min-width: 250px;" style={this.propertygrid ? { minWidth: 0 } : undefined}>
                        {input}
                    </td>
                </tr>
            );
        }
        catch (err) {
            console.error('Exception in form-input', err);
            return <div>Exception in form-input: {err.message}</div>;
        }
    }
});